import { Navigate, useParams } from 'react-router-dom'

// Redirects a legacy trip sub-route to its new home. `to` is the suffix after
// the group id ('' = trip home/Expenses, 'settle' = Settle screen).
export default function LegacyRedirect({ to }) {
  const { groupId } = useParams()
  const suffix = to ? `/${to}` : ''
  return <Navigate to={`/groups/${groupId}${suffix}`} replace />
}
